<div class="route-component">
    <div class="search-component">
        <h4>
            Audit Logs
        </h4>

        <p>Audit logs are detailed records of system or application activity</p>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['AuditLog', 'Export']" (click)="downloadAuditLogs(paging)">
                        Download <i class="fas fa-download"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">
                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="auditLogs"
            [paging]="paging"
            [columns]="getColumnMap()"
            [showView]="true"
            (viewItem)="viewAuditResults($event)"
            (refreshData)="getAuditLogs($event)">
        </pageable-table>
    </div>
</div>